import { Route, RouteChildrenProps, RouteComponentProps, RouteProps } from 'react-router';
import { Location } from 'history';
import React from 'react';
// import AsyncMenus from './menus/AsyncMenus';
import AsyncMenus from './menus/sync/Menus';
import { AsyncLoader } from '@libs/a-component';
import * as QS from 'query-string';

export type TModule = () => Promise<{ default: any }>;
const documentTitle = document.title;

type TMenuType = 'item' | 'group-divide' | 'group';

// @ts-ignore
export interface IRouteSetting extends RouteProps {
    isRoot?: boolean;
    path: string;
    dynamicPath?(router: RouteSetting): string;
    menuKey?: string;
    onMenuItemClick?: (router: RouteSetting) => boolean;
    selectMenuKey?: string;
    forbiddenMenu?: boolean;
    fullScreen?: boolean;
    iconType?: React.ReactNode;
    title?: string | React.ReactNode;
    importPromise?: TModule;
    customDocTitle?: boolean; // 默认使用 title
    qsFields?: string[];
    routeSettings?: Array<RouteSetting | IRouteSetting>;
    parent?: RouteSetting;
    defaultOpen?: boolean;
    type?: TMenuType; // 'group-divide'菜单分组 菜单项分割线
    dataUITestInfo?: string; // ui 自动化测试
    needsCheckSpacePermission?: boolean; // 是否需要检查空间权限
}

function onChangeTitle(route: RouteSetting) {
    const titles: string[] = [];
    route.title && titles.push(route.title);
    let parent = route.parent;
    while (parent) {
        parent.title && titles.push(parent.title);
        parent = parent.parent;
    }
    titles.push(documentTitle);
    document.title = titles.join(' · ');
}

const STYLE_fullScreen: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    backgroundColor: '#fff',
};

export class RouteSetting implements IRouteSetting {
    private static RouterMap: Map<string, RouteSetting> = new Map();

    public static renderRoutes(router: RouteSetting): React.ReactNode {
        if (!router.routeSettings) {
            return <Route key={router.getKey()} {...router.getRouteProps()} />;
        }
        const children = router.routeSettings.map(it => {
            return this.renderRoutes(it);
        });
        return children;
    }

    public static isFullScreen(): boolean {
        const rs = RouteSetting.RouterMap.get(location.pathname);
        return !!rs && rs.fullScreen === true;
    }

    public readonly location?: Location;
    public readonly component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
    public readonly render?: ((props: RouteComponentProps<any>) => React.ReactNode);
    public readonly children?: ((props: RouteChildrenProps<any>) => React.ReactNode) | React.ReactNode;
    public path: string;
    public dynamicPath?(router: RouteSetting): string;
    public menuKey?: string;
    public defaultOpen?: boolean;
    public selectMenuKey?: string;
    public isRoot: boolean = false;
    public exact: boolean = true;
    public readonly sensitive?: boolean;
    public readonly strict?: boolean;

    public readonly dataUITestInfo?: string;

    public readonly forbiddenMenu?: boolean;
    public readonly fullScreen?: boolean;
    public readonly iconType?: React.ReactNode;
    public readonly title?: string;
    public readonly customDocTitle?: boolean;
    public qsFields: string[];
    public importPromise?: TModule; // = () => Promise.resolve({ default: '' });

    public type?: TMenuType; // 'group-divide'菜单分组 菜单项分割线

    public routeSettings?: Array<RouteSetting>;
    public parent?: RouteSetting;

    public onMenuItemClick?: (router: RouteSetting) => boolean;

    constructor(p: IRouteSetting) {
        this.path = p.path;
        Object.assign(this, p);
        RouteSetting.RouterMap.set(this.path, this);
        if (p.importPromise != null) {
            this.render = () => {
                this.customDocTitle !== true && onChangeTitle(this); // title 不配置默认不触发
                if (this.fullScreen) {
                    return <div style={ STYLE_fullScreen }><AsyncLoader compoLazy={ p.importPromise } /></div>;
                }
                return <AsyncLoader compoLazy={ p.importPromise } />;
            };
        }
        if (p.routeSettings) {
            this.routeSettings = p.routeSettings.map<RouteSetting>(
                it => {
                    if (it instanceof RouteSetting) {
                        it.parent = this;
                        return it;
                    }
                    return new RouteSetting(Object.assign(it, { parent: this }));
                },
            );
            if (!this.render && p.routeSettings && p.routeSettings.length > 0) {
                this.render = p.routeSettings[0].render;
            }
        }
        this.qsFields = p.qsFields || [];
    }

    public getRouteProps(): RouteProps {
        const { title, importPromise, iconType, routeSettings, isRoot, forbiddenMenu, parent, ...props } = this;
        return { ...props };
    }

    public getMenuKey(): string {
        return this.selectMenuKey || this.menuKey || this.path as string;
    }

    public getKey(): string {
        return this.path as string;
    }

    public getQsFields() {
        const qs = QS.parse(location.search);
        const params = this.qsFields.reduce((result, current) => {
            result[current] = qs[current] || '';
            return result;
        }, {}) || {};
        return params;
    }

    public renderRoutes(): React.ReactNode {
        return RouteSetting.renderRoutes(this);
    }

    public renderMenus(
        extraFooter?: React.ReactNode,
        menuClick?: (menuName: string | undefined) => void
    ): React.ReactNode {
        if (RouteSetting.isFullScreen()) {
            return null;
        }
        return (
            <AsyncMenus router={ this } extraFooter={extraFooter} menuClick={ menuClick }/>
        );
    }
}

export default RouteSetting;
